module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "casus"
  }, [_c('div', {
    staticClass: "card_1",
    style: ({
      backgroundImage: 'url(' + _vm.img.bgCard_1 + ')'
    })
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    staticClass: "phone_border",
    attrs: {
      "src": require("../assets/img/casus/pone.png")
    }
  }), _vm._v(" "), _vm._l((_vm.aPointImgList), function(item, i) {
    return [_c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [(_vm.iPointIndex == (i + 1)) ? _c('img', {
      staticClass: "phone_content",
      attrs: {
        "src": _vm.aPointImgList[i]
      }
    }) : _vm._e()])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "point-list"
  }, [_vm._l((_vm.aPointImgList.length), function(i) {
    return [_c('div', {
      staticClass: "point",
      class: {
        active: _vm.iPointIndex == i
      },
      on: {
        "click": function($event) {
          _vm.fnPointClick(i)
        }
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card_2",
    style: ({
      backgroundImage: 'url(' + _vm.img.bgCard_2 + ')'
    })
  }, [_c('h1', [_vm._v("智能软件制定开发")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', [_vm._v("针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。")]), _vm._v(" "), _c('p', [_vm._v("让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/casus/pic_version.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card_3"
  }, [_c('h1', [_vm._v("案例展示")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', [_vm._l((_vm.aList), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])]
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "card_4"
  }, [_c('h1', [_vm._v("受益用户")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.aCard), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])])]
  })], 2)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("客户成功案例")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', [_vm._v("针对各行业业务特性，打造个性化行业解决方案，为客户提供一站式的产品与服务。")]), _vm._v(" "), _c('p', [_vm._v("让客户可以轻松实现物联网产品的开发和管理，让产品互联互通。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-47fabd2e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Casus.vue
// module id = 782
// module chunks = 1